module.exports = __webpack_public_path__ + "static/media/etude-exploratoire-internationnale-sur-les-routines-beautes-des-femmes.d72891e8.jpg";